import React from "react";
import IconSvg, { IconSvgProps } from "~/guidelines/Icon/IconSvg";

const KeyboardArrowLeft = ({ color }: IconSvgProps) => {
  return (
    <IconSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <path
        d="M15.228 15.875L11.348 11.995L15.228 8.11499C15.618 7.72499 15.618 7.09499 15.228 6.70499C15.0412 6.51774 14.7875 6.41251 14.523 6.41251C14.2585 6.41251 14.0048 6.51774 13.818 6.70499L9.22802 11.295C8.83802 11.685 8.83802 12.315 9.22802 12.705L13.818 17.295C14.208 17.685 14.838 17.685 15.228 17.295C15.608 16.905 15.618 16.265 15.228 15.875Z"
        fill="currentColor"
      />
    </IconSvg>
  );
};

export default KeyboardArrowLeft;
